import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "input", "menu" ]

  toggle(event) {
    event.stopPropagation()
    this.menuTarget.classList.toggle("hidden")
  }

  hide(event) {
    if (!this.element.contains(event.target)) {
      this.menuTarget.classList.add("hidden")
    }
  }

  apply(event) {
    const value = event.currentTarget.dataset.value

    if (value) {
      this.inputTarget.value = value
      this.menuTarget.classList.add("hidden")
      this.inputTarget.focus()
      this.inputTarget.dispatchEvent(new Event('input', { bubbles: true }))
    }
  }

  clear(event) {
    this.inputTarget.value = ""
    this.inputTarget.focus()

    this.inputTarget.dispatchEvent(new Event('input', { bubbles: true }))
  }
}
